<template lang="pug">
    el-dialog(:title="title",width="95%",:visible.sync='visible' :modal-append-to-body='false')
        el-form(:model="ruleForm",:inline="false", :rules="rules", ref="ruleForm" label-width="120px")
            el-card(shadow="never")
                div
                    el-form-item(label="规程标题:" prop="title")
                        font {{ruleForm.title}}
                    el-form-item(label="摘    要:" prop="remark")
                        font {{ruleForm.remark}}
                    el-form-item(label="发布日期:" prop="releaseTim")
                        font {{ruleForm.releaseTim}}
                    el-form-item(label="类型:" prop="type")
                        font {{ruleForm.type}}
                    el-form-item(label="文件:")
                        a(:href="filePath" :download="fileName" style='color:#606266' v-if="filePath!=''") {{fileName}}
                        //- <img  v-if='listImageUrl' :src="listImageUrl" :onerror="defaultImg" style="width:100px;height:100px"/>
                        <span v-else style="width:100px;height:100px">暂无文件</span>
                    el-form-item(label="正文:" prop="details")
                        div(v-html="ruleForm.details" style='width:80%;')
        span.dialog-footer(slot="footer")
            el-button(@click="visible=false") 返 回

</template>
<script>
    export default {
        data () {
            return {
                defaultImg: '../../../mb/img/img.jpg',
                flagType: '',

                title: '查看详情',

                ruleForm: {
                    title: '',
                    remark: '',
                    type: '',
                    releaseTim: '',
                    attach: '',
                    details: '',
                    id: null
                },
                visible: false,
                listImageUrl: '',
                filePath: '',
                fileName: ''
            }
        },
        methods: {
            init (id, flagType) {
                this.flagType = flagType
                this.ruleForm.id = id || null
                this.visible = true
                this.listImageUrl = ''
                this.$nextTick(() => {
                    this.$refs['ruleForm'].resetFields()
                })

                //数据初始
                //修改回选
                if (this.ruleForm.id) {
                    this.$http({
                        url: this.$http.adornUrl(`/pbStandards/getId/` + this.ruleForm.id),
                        method: 'get'
                    }).then((data) => {
                        if (data && data.code === 0) {
                            console.log(data)
                            this.ruleForm.title = data.bean.title
                            this.ruleForm.remark = data.bean.remark
                            this.ruleForm.type = this.bclx(data.bean.type)
                            this.ruleForm.releaseTim = data.bean.releaseTime
                            this.ruleForm.details = data.bean.details

                            if (data.bean.imgUrl != '' && data.bean.imgUrl != null) {
                                this.filePath = data.bean.imgUrl
                                this.fileName = data.bean.imgName
                                // this.listImageUrl = "data:image/png;base64,"+data.bean.imgUrl
                            }
                        }
                    })
                }
            },
            bclx (val) {
                let obj = {
                    1: '竞赛',
                    2: '培训'
                }
                if (obj[val]) return obj[val]
            }

        }
    }
</script>
<style  scoped>

</style>
